import { useEffect, useState } from 'react';
import {
  Box,
  RadioGroup,
  Radio,
  TableBody,
  TableRow,
  TableContainer,
} from '@mui/material';
import Form from 'components/Form';
import {
  StyledTableCellTwo,
  StyledTableCellWithoutLeftTwo,
  StyledTableCellWithoutLeftRightTwo,
} from 'routes/Main/style';
import SectionTitle from '../../components/SectionTitle';

import { IFormValues, IFormWatch, IFormRegister } from 'routes/Main/type';

const radioId7_1 = ['no19', 'no20'];

const 영역7_1 = [
  {
    id: 1,
    ko: '19. 혈당검사',
    info: [''],
    desc: ['해당 없음', '1점: 1~4회', '2점 : 5회 이상'],
  },
  {
    id: 2,
    ko: '20. 추가 혈액 검사',
    info: ['정규 혈액 검사만 시행한 경우엔 해당안됨'],
    desc: ['해당 없음', '2점'],
  },
];

const radioId7_2 = ['no21', 'no22', 'no23', 'no24', 'no25'];

const 영역7_2 = [
  {
    id: 1,
    ko: '21. 수액교환',
    info: [
      '항생제를 mix하는 DSW 50cc, N/S 50cc 등은 해당 안되며 수액만 해당됨',
    ],
    desc: ['해당 없음', '1점: 2회 이하', '3점: 3~4회', '4점: 5회 이상'],
  },
  {
    id: 2,
    ko: `22. 정맥투여로 2개 이상 또는 \n        multilumen 사용`,
    info: [''],
    desc: ['해당 없음', '1점'],
  },
  {
    id: 3,
    ko: '23. 정맥내 투약',
    info: [
      '환자에게 투여한 약품별 투여횟수의 합을 말함',
      '1회 방문으로 2개 동시 투약하는 경우 2회로 환자에게 투여된 경우에만 count함',
    ],
    desc: ['해당 없음', '1점 : 3~5회', '2점 : 6~9회', '3점 : 10회 이상'],
  },
  {
    id: 4,
    ko: '24. 수혈-횟수로 표시',
    info: [
      '혈액 확인, V/S check, 환자 관찰 등을 모두 포함',
      '혈소판, Cryo는 6unit 당 1회',
    ],
    desc: ['해당 없음 ', '1회 당 2점 :'],
  },
  {
    id: 5,
    ko: '25. 기타투약 방문',
    info: [
      '정맥 투약을 제외한 경구투약, 설하, 피하주사, 근육주사, 좌약, 안약, 흡입제, eardrops, 연고 등',
      '약품 개수가 아니고 투약을 위한 환자 방문 횟수임',
      '1회 방문으로 2개 이상 동시 투약하는 경우 1회로 투약은 환자에게 투여된 경우에만 count함',
      '약 준비, 설명, 투여가 포함되며 기록이 있어야 함',
    ],
    desc: ['해당 없음', '1점 : 3~5회', '2점 : 6~10회', '3점 : 11회 이상'],
  },
];

interface Props extends IFormValues, IFormWatch, IFormRegister {
  disabled?: boolean;
  sum7: number;
  setSum7: (sum7: number) => void;

  sum8: number;
  setSum8: (sum8: number) => void;

  trancfusion: number;
  setTransfusion: (trancfusion: number) => void;
}

const KPCSCGWontents4 = (props: Props) => {
  const {
    disabled,
    setValue,
    getValues,
    setSum7,
    setSum8,
    setTransfusion,
    register,
  } = props;

  const calculateSumValue7_1 = () => {
    setSum7(
      radioId7_1.reduce((acc, cur) => {
        if (cur === 'no20') {
          const value = Number(getValues(cur)) * 2;
          return value ? acc + value : acc;
        }
        const value = Number(getValues(cur));
        return value ? acc + value : acc;
      }, 0)
    );
  };

  const handleChange7_1 = (
    e: React.ChangeEvent<HTMLInputElement>,
    checked: boolean
  ) => {
    setValue(e.target.name, e.target.value);
    calculateSumValue7_1();
  };

  const calculateSumValue7_2 = () => {
    setSum8(
      radioId7_2.reduce((acc, cur) => {
        if (cur === 'no21' && Number(getValues(cur)) > 1) {
          const value = Number(getValues(cur)) + 1;
          return value ? acc + value : acc;
        } else if (cur === 'no24') {
          const value = Number(getValues(cur));
          return value ? acc + value - 1 : acc;
        }
        const value = Number(getValues(cur));
        return value ? acc + value : acc;
      }, 0)
    );
  };

  const handleChange7_2 = (
    e: React.ChangeEvent<HTMLInputElement>,
    checked: boolean
  ) => {
    setValue(e.target.name, e.target.value);
    calculateSumValue7_2();
  };
  const [disableTF, setDisableTF] = useState(false);

  const handleChange7_24_none = (
    e: React.ChangeEvent<HTMLInputElement>,
    checked: boolean
  ) => {
    setValue(e.target.name, e.target.value);
    setValue('no24_1', 0);
    setTransfusion(0);
    setDisableTF(true);
    calculateSumValue7_2();
  };

  const handleChange7_24_One = (
    e: React.ChangeEvent<HTMLInputElement>,
    checked: boolean
  ) => {
    setValue(e.target.name, e.target.value);
    setValue('no24_1', 1);
    setTransfusion(2);
    setDisableTF(false);
    calculateSumValue7_2();
  };

  useEffect(() => {
    calculateSumValue7_1();
    calculateSumValue7_2();
  }, []);

  return (
    <>
      <SectionTitle title="영역 : 검사" />
      <Box sx={{ width: '98%', margin: '20px' }}>
        <TableContainer sx={{ marginTop: '20px', marginBottom: '30px' }}>
          <TableBody>
            {영역7_1.map(
              (
                content: {
                  id: number;
                  ko: string;
                  info: string[];
                  desc: string[];
                },
                i
              ) => (
                <TableRow>
                  <StyledTableCellTwo
                    sx={{
                      padding: '16px',
                      width: '300px',
                      whiteSpace: 'pre-wrap',
                      verticalAlign: 'top',
                      borderBottom: 영역7_1.length - 1 === i ? 'none' : '',
                    }}
                  >
                    {content.ko}
                  </StyledTableCellTwo>
                  <StyledTableCellWithoutLeftTwo
                    sx={{
                      borderBottom: 영역7_1.length - 1 === i ? 'none' : '',
                    }}
                  >
                    <RadioGroup
                      sx={{
                        paddingTop: content.info.length > 1 ? '43px' : '28px',
                        marginTop: content.ko.includes('33.') ? '5px' : '0px',
                      }}
                      name={radioId7_1[content.id - 1]}
                      defaultValue={Number(
                        getValues(radioId7_1[content.id - 1])
                      )}
                    >
                      {content.desc.map((point, i) => {
                        return (
                          <TableRow
                            sx={{
                              lineHeight: '43px',
                              textAlign: 'center',
                            }}
                          >
                            <Box>
                              <Radio
                                disabled={disabled}
                                name={radioId7_1[content.id - 1]}
                                value={i}
                                onChange={handleChange7_1}
                              />
                            </Box>
                          </TableRow>
                        );
                      })}
                    </RadioGroup>
                  </StyledTableCellWithoutLeftTwo>
                  <StyledTableCellWithoutLeftRightTwo
                    sx={{
                      borderBottom: 영역7_1.length - 1 === i ? 'none' : '',
                    }}
                  >
                    <Box>
                      {content.info.includes('') ? (
                        <TableRow
                          sx={{
                            height: '16px',
                          }}
                        >
                          <Box sx={{ minWidth: '500px' }}> </Box>
                        </TableRow>
                      ) : content.info.length > 1 ? (
                        content.info.map((item, i) => {
                          return (
                            <TableRow
                              sx={{
                                lineHeight: '17px',
                                height: '4px',
                              }}
                            >
                              <Box
                                sx={{ minWidth: '65vw', marginLeft: '-28px' }}
                              >
                                ・ {item}
                              </Box>
                            </TableRow>
                          );
                        })
                      ) : (
                        content.info.map((item, i) => {
                          return (
                            <TableRow
                              sx={{
                                height: '8.5px',
                              }}
                            >
                              <Box
                                sx={{ minWidth: '65vw', marginLeft: '-28px' }}
                              >
                                ・ {item}
                              </Box>
                            </TableRow>
                          );
                        })
                      )}
                      {content.desc.map((v, i) => {
                        return (
                          <TableRow
                            sx={{
                              lineHeight: '42px',
                            }}
                          >
                            <Box sx={{ minWidth: '500px' }}>{v}</Box>
                          </TableRow>
                        );
                      })}
                    </Box>
                  </StyledTableCellWithoutLeftRightTwo>
                </TableRow>
              )
            )}
          </TableBody>
        </TableContainer>

        <SectionTitle title="영역 : 투약 및 수혈" />
        <TableContainer sx={{ marginTop: '40px', marginBottom: '-30px' }}>
          <TableBody>
            {영역7_2.map(
              (
                content: {
                  id: number;
                  ko: string;
                  info: string[];
                  desc: string[];
                },
                i
              ) => (
                <TableRow>
                  <StyledTableCellTwo
                    sx={{
                      padding: '16px',
                      width: '300px',
                      whiteSpace: 'pre-wrap',
                      verticalAlign: 'top',
                      borderBottom: 영역7_2.length - 1 === i ? 'none' : '',
                    }}
                  >
                    {content.ko}
                  </StyledTableCellTwo>
                  <StyledTableCellWithoutLeftTwo
                    sx={{
                      borderBottom: 영역7_2.length - 1 === i ? 'none' : '',
                    }}
                  >
                    <RadioGroup
                      sx={{
                        paddingTop: content.info.length > 1 ? '43px' : '28px',
                        marginTop: content.ko.includes('25.') ? '35px' : '0px',
                      }}
                      name={radioId7_2[content.id - 1]}
                      defaultValue={Number(
                        getValues(radioId7_2[content.id - 1])
                      )}
                    >
                      {content.desc.map((point, i) => {
                        if (point === '') {
                          return (
                            <TableRow
                              sx={{
                                lineHeight: '43px',
                                textAlign: 'center',
                                height: '43px',
                              }}
                            ></TableRow>
                          );
                        } else if (point === '해당 없음 ') {
                          return (
                            <TableRow
                              sx={{
                                lineHeight: '43px',
                                textAlign: 'center',
                              }}
                            >
                              <Box>
                                <Radio
                                  disabled={disabled}
                                  name={'no24'}
                                  value={i}
                                  onChange={handleChange7_24_none}
                                />
                              </Box>
                            </TableRow>
                          );
                        } else if (point === '1회 당 2점 :') {
                          return (
                            <TableRow
                              sx={{
                                lineHeight: '43px',
                                textAlign: 'center',
                              }}
                            >
                              <Box>
                                <Radio
                                  disabled={disabled}
                                  name={'no24'}
                                  value={i}
                                  onChange={handleChange7_24_One}
                                />
                              </Box>
                            </TableRow>
                          );
                        } else
                          return (
                            <TableRow
                              sx={{
                                lineHeight: '43px',
                                textAlign: 'center',
                              }}
                            >
                              <Box>
                                <Radio
                                  disabled={disabled}
                                  name={radioId7_2[content.id - 1]}
                                  value={i}
                                  onChange={handleChange7_2}
                                />
                              </Box>
                            </TableRow>
                          );
                      })}
                    </RadioGroup>
                  </StyledTableCellWithoutLeftTwo>
                  <StyledTableCellWithoutLeftRightTwo
                    sx={{
                      borderBottom: 영역7_2.length - 1 === i ? 'none' : '',
                    }}
                  >
                    <Box>
                      {content.info.includes('') ? (
                        <TableRow
                          sx={{
                            height: '16px',
                          }}
                        >
                          <Box sx={{ minWidth: '500px' }}> </Box>
                        </TableRow>
                      ) : content.info.length > 1 ? (
                        content.info.map((item, i) => {
                          return (
                            <TableRow
                              sx={{
                                lineHeight: '17px',
                                height: '4px',
                              }}
                            >
                              <Box
                                sx={{ minWidth: '65vw', marginLeft: '-28px' }}
                              >
                                ・ {item}
                              </Box>
                            </TableRow>
                          );
                        })
                      ) : (
                        content.info.map((item, i) => {
                          return (
                            <TableRow
                              sx={{
                                height: '8.5px',
                              }}
                            >
                              <Box
                                sx={{ minWidth: '65vw', marginLeft: '-28px' }}
                              >
                                ・ {item}
                              </Box>
                            </TableRow>
                          );
                        })
                      )}
                      {content.desc.map((v, i) => {
                        if (v === '1회 당 2점 :') {
                          return (
                            <TableRow
                              sx={{
                                lineHeight: '42px',
                              }}
                            >
                              <Box sx={{ minWidth: '500px' }}>
                                {v}
                                <Form.MuiTextField
                                  required={false}
                                  type="number"
                                  textAlign="right"
                                  disabled={disableTF ? true : disabled}
                                  sx={{ width: '200px', marginLeft: '10px' }}
                                  InputProps={{
                                    ...Form.adornment('', '회'),
                                  }}
                                  {...register('no24_1', {
                                    onChange: e => {
                                      setValue(
                                        'no24_1',
                                        Number(e.target.value)
                                      );
                                      setTransfusion(
                                        Math.floor(getValues('no24_1') * 2)
                                      );
                                    },
                                  })}
                                />
                              </Box>
                            </TableRow>
                          );
                        } else {
                          return (
                            <TableRow
                              sx={{
                                lineHeight: '42px',
                              }}
                            >
                              <Box sx={{ minWidth: '500px' }}>{v}</Box>
                            </TableRow>
                          );
                        }
                      })}
                    </Box>
                  </StyledTableCellWithoutLeftRightTwo>
                </TableRow>
              )
            )}
          </TableBody>
        </TableContainer>
      </Box>
    </>
  );
};

export default KPCSCGWontents4;
